import { FunctionComponent, memo } from "react";
import { ITag, ITagGroup } from "@edgetier/watchtower-types";
import { SpinnerUntil } from "@edgetier/components";

import { Page, PageContent, PageHeader } from "@edgetier/client-components";
import { clearUrlParameters } from "@edgetier/utilities";
import ExploreFilters from "components-for/filters/explore-filters";
import useTagGroups from "hooks-for/tag-groups/use-tag-groups";
import useTags from "hooks-for/tags/use-tags";
import { INTERACTIONS_TABLE_PREFIX } from "constants/interactions";
import ExploreResults from "./explore-results";
import { IProps } from "./explore.types";
import { ExploreContextProvider } from "components-for/explore/explore-context/explore-context-provider";
import "./explore.scss";

/**
 * Page to allow users to search for phrases filtered by language, tags etc.
 * @returns Explore page.
 */
const Explore: FunctionComponent<IProps> = () => {
    const { data: tagGroups, isLoading: areTagGroupsLoading } = useTagGroups();
    const { data: tags, isLoading: areTagsLoading } = useTags();

    return (
        <Page className="explore">
            <PageHeader title="Explore" />
            <PageContent>
                <SpinnerUntil<{ tags: ITag[]; tagGroups: ITagGroup[] }>
                    data={{ tagGroups, tags }}
                    isReady={!areTagGroupsLoading && !areTagsLoading}
                >
                    {(data) => (
                        <ExploreContextProvider>
                            <ExploreFilters
                                tags={data.tags || []}
                                tagGroups={data.tagGroups || []}
                                trackingEventName="Search"
                                visibleFields={["search", "interactionType", "languageIsoCode"]}
                                onChangeCallback={(parameters) =>
                                    clearUrlParameters(parameters, INTERACTIONS_TABLE_PREFIX)
                                }
                            />
                            <ExploreResults />
                        </ExploreContextProvider>
                    )}
                </SpinnerUntil>
            </PageContent>
        </Page>
    );
};

export default memo(Explore);
